import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Aula} from "../_Models/aula";
import {Subscription} from "rxjs";
import {FormazioneStoreService} from "../_services/formazione-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-aule-edit',
  templateUrl: './aule-edit.component.html'
})
export class AuleEditComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  @Input() IsModal: boolean = true;
  @Input() SedeSelezionata: number;
  @Output() updated = new EventEmitter<Aula>();
  @Output() added = new EventEmitter<Aula>();
  selected: Aula;
  constructor(
    private FormazioneStore: FormazioneStoreService,
    private ApiRestService: ApiRestService,
    private modalService: NgbModal,
    ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.FormazioneStore.$aula.subscribe(data => {
      if (data)
        this.selected = data;
    }))
  }
  saveModalButton() {
    if (this.selected && !isNaN(this.selected.id)) {
      this.ApiRestService.UpdateAula(this.selected).subscribe(data => {
        this.updated.emit(data);
        this.closeBtnClick();
      });
    } else if (this.selected && (isNaN(this.selected.id) || this.selected.id < 1)) {
      this.selected.id_sede = this.SedeSelezionata;
      this.ApiRestService.AddAula(this.selected).subscribe(data => {
        this.added.emit(data);
        this.closeBtnClick();
      });
    }
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }

}
